export default "__VITE_ASSET__BBbQL_va__";